(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["infinity-card-tags"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.customElements || customElements.get('infinity-care-tags')) return;
    if (!window.IntersectionObserver || !window.ResizeObserver || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;

    let sharedDialog;
    let dialogOpener;

    function getDialog() {
      if (sharedDialog) return sharedDialog;
      const dialog = document.createElement('dialog');
      dialog.className = 'inf-care-dialog';
      dialog.id = 'infinity-care-concerns-dialog';
      dialog.setAttribute('aria-labelledby', 'infinity-care-concerns-heading');
      dialog.setAttribute('aria-describedby', 'infinity-care-concerns-product');
      // Static markup only. Product names and labels are assigned as text below.
      dialog.innerHTML = `
        <span class="inf-care-dialog__brand" dir="ltr">INFINITY CARE</span>
        <button class="inf-care-dialog__close" type="button" autofocus aria-label="Close">&times;</button>
        <h2 class="inf-care-dialog__heading" id="infinity-care-concerns-heading"></h2>
        <p class="inf-care-dialog__product" id="infinity-care-concerns-product"></p>
        <nav class="inf-care-dialog__links"></nav>`;
      document.body.appendChild(dialog);
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (dialogOpener && dialogOpener.isConnected && !dialogOpener.hidden) dialogOpener.focus({ preventScroll: true });
        dialogOpener = null;
      });
      sharedDialog = dialog;
      return dialog;
    }

    // One scheduler separates every layout read from writes across all cards.
    // Only rows near the viewport are enhanced; offscreen rows remain native links.
    const activeRows = new Set();
    const pendingRows = new Set();
    const railOwners = new WeakMap();
    let scheduled = false;
    function scheduleBatch() {
      if (scheduled || !pendingRows.size) return;
      scheduled = true;
      requestAnimationFrame(() => {
        const batch = Array.from(pendingRows).slice(0, 12);
        batch.forEach(row => pendingRows.delete(row));
        const connected = batch.filter(row => row.isConnected && activeRows.has(row));
        connected.forEach(row => row.prepareFit());
        requestAnimationFrame(() => {
          // Read ALL measurements first. No hide/show writes inside this map.
          const plans = connected.map(row => row.isConnected ? row.measureFit() : null);
          connected.forEach((row, index) => { if (row.isConnected && plans[index]) row.applyFit(plans[index]); });
          scheduled = false;
          scheduleBatch();
        });
      });
    }
    const sizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const row = railOwners.get(entry.target);
        if (!row || !activeRows.has(row)) return;
        const width = entry.contentRect.width;
        if (Math.abs(width - (row.lastWidth || 0)) < 0.5) return;
        row.lastWidth = width;
        row.queueFit();
      });
    });
    const visibilityObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const row = entry.target;
        if (entry.isIntersecting) {
          activeRows.add(row);
          sizeObserver.observe(row.rail);
          row.queueFit();
        } else {
          activeRows.delete(row);
          pendingRows.delete(row);
          sizeObserver.unobserve(row.rail);
        }
      });
    }, { rootMargin: '240px 0px' });
    const refitVisible = () => activeRows.forEach(row => row.queueFit());
    if (document.fonts) {
      document.fonts.ready.then(refitVisible);
      document.fonts.addEventListener('loadingdone', refitVisible);
    }

    class InfinityCareTags extends HTMLElement {
      connectedCallback() {
        // A microtask permits fragment insertion to finish without reading layout.
        queueMicrotask(() => this.connect());
      }
      connect() {
        if (!this.isConnected || this.onClick) return;
        this.rail = this.querySelector('.inf-card-tags__rail');
        this.links = Array.from(this.querySelectorAll('.inf-card-tags__link'));
        this.more = this.querySelector('.inf-card-tags__more');
        if (!this.rail || !this.more || !this.links.length) return;
        this.counter = this.more.querySelector('bdi');
        this.onClick = event => {
          const target = event.target.closest('.inf-card-tags__link, .inf-card-tags__more');
          if (!target) return;
          event.stopPropagation();
          if (target === this.more) this.openConcerns();
        };
        this.addEventListener('click', this.onClick);
        railOwners.set(this.rail, this);
        visibilityObserver.observe(this);
      }
      disconnectedCallback() {
        visibilityObserver.unobserve(this);
        if (this.rail) sizeObserver.unobserve(this.rail);
        activeRows.delete(this);
        pendingRows.delete(this);
        if (this.onClick) this.removeEventListener('click', this.onClick);
        this.onClick = null;
        if (dialogOpener === this.more && sharedDialog?.open) sharedDialog.close();
      }
      queueFit() {
        if (!this.isConnected || !activeRows.has(this)) return;
        pendingRows.add(this);
        scheduleBatch();
      }
      prepareFit() {
        this.removeAttribute('data-summary');
        this.links.forEach(link => { if (link.hidden) link.hidden = false; });
        this.more.hidden = false;
      }
      measureFit() {
        const available = this.rail.clientWidth;
        if (!available) return null;
        const widths = this.links.map(link => link.offsetWidth);
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 6;
        const moreWidth = this.more.offsetWidth;
        const limit = Math.max(1, Number(this.dataset.visibleLimit) || 2);
        const total = this.links.length;
        let visible = Math.min(total, limit);
        while (visible > 0) {
          const inlineWidth = widths.slice(0, visible).reduce((sum, width) => sum + width, 0);
          const extraWidth = visible < total ? gap + moreWidth : 0;
          if (inlineWidth + gap * (visible - 1) + extraWidth <= available) break;
          visible -= 1;
        }
        return { visible, total, active: document.activeElement };
      }
      applyFit({ visible, total, active }) {
        if (!visible) this.setAttribute('data-summary', '');
        this.links.forEach((link, index) => { link.hidden = index >= visible; });
        const remaining = total - visible;
        this.more.hidden = remaining === 0;
        const count = '+' + remaining;
        if (this.counter.textContent !== count) this.counter.textContent = count;
        const label = this.dir === 'rtl' ? 'تصنيفات العناية' : (visible ? 'more concerns' : 'care concerns');
        this.more.setAttribute('aria-label', remaining + ' ' + label + ' — ' + this.dataset.productTitle);
        this.setAttribute('data-enhanced', '');
        if (active && this.contains(active) && active.hidden) {
          (this.more.hidden ? this.links[0] : this.more).focus({ preventScroll: true });
        }
      }

      openConcerns() {
        const dialog = getDialog();
        const isArabic = this.dir === 'rtl';
        dialog.dir = this.dir;
        dialog.style.fontFamily = getComputedStyle(this).fontFamily;
        dialog.querySelector('h2').textContent = this.getAttribute('aria-label');
        dialog.querySelector('p').textContent = this.dataset.productTitle;
        dialog.querySelector('button').setAttribute('aria-label', isArabic ? 'إغلاق' : 'Close');
        const list = dialog.querySelector('nav');
        list.setAttribute('aria-label', this.getAttribute('aria-label'));
        list.replaceChildren(...this.links.map((source) => {
          const link = source.cloneNode(true);
          link.hidden = false;
          link.removeAttribute('style');
          link.className = 'inf-care-dialog__link';
          link.querySelector('.inf-card-tags__text').textContent = source.dataset.fullLabel;
          return link;
        }));
        dialogOpener = this.more;
        this.more.setAttribute('aria-controls', dialog.id);
        dialog.showModal();
      }
    }

    customElements.define('infinity-care-tags', InfinityCareTags);
  })();
  } catch(e) { console.error(e); }
})();

})();
